import { SUCCESS, FAIL, LOADING, FINISHED } from 'constants';

let dispatch;
//let getState;
export const setDispatcher = (newDispatch, newGetState) => {
  dispatch = newDispatch;
  //getState = newGetState;
};

const common = (type, request, payload) => {
  const path = type.replace('.', '_').toLowerCase();
  return {
    type: `FETCH.${type}`,
    payload: {
      [path]: {
        timestamp: new Date().toISOString(),
        type,
        request,
        ...payload
      }
    }
  };
};

const loading = (type, request) => common(type, request, { status: LOADING, is_loading: true });
const success = (type, request) => common(type, request, { status: SUCCESS, is_success: true });
const fail = (type, error_message, request) => common(type, request, { status: FAIL, is_error: true, error_message });
const finished = type => common(type, null, { status: FINISHED, is_finished: true });

export const markFinished = type => dispatch(finished(type));

export const fetch = async (request, action, callback) => {
  const action_type = typeof action === 'function' ? action({}).type : action;
  const method = request.method;
  delete request.method;
  try {
    dispatch(loading(action_type, request));
    const data = await method(request);
    if (typeof action === 'function') {
      dispatch(action(data));
    }
    callback && callback(data);

    dispatch(success(action_type, request));
  } catch (err) {
    console.log(`Caught an error for action: ${action_type} `);
    console.log(`XX This is our error: `, err);
    dispatch(fail(action_type, err, request));
  }
};



// WEBPACK FOOTER //
// ./src/actions/fetch.js